(() => {
  const roots = document.querySelectorAll('[data-sk-guide-article]');
  roots.forEach((root) => {
    const content = root.querySelector('[data-sk-guide-content]');
    const toc = root.querySelector('[data-sk-guide-toc]');
    if (content) {
      const tableHintText = root.getAttribute('data-sk-guide-table-hint') || '';
      content.querySelectorAll('.sk-guide-table-wrap').forEach((wrap, index) => {
        if (!wrap.querySelector('table')) return;
        if (!wrap.hasAttribute('tabindex')) wrap.setAttribute('tabindex', '0');
        if (!wrap.hasAttribute('role')) wrap.setAttribute('role', 'region');
        if (tableHintText && !wrap.previousElementSibling?.classList?.contains('sk-guide-table-scroll-hint')) {
          const hint = document.createElement('p');
          hint.className = 'sk-guide-table-scroll-hint';
          hint.id = 'sk-guide-table-scroll-hint-' + index;
          hint.textContent = tableHintText;
          wrap.setAttribute('aria-describedby', hint.id);
          wrap.parentNode.insertBefore(hint, wrap);
        }
        const updateOverflow = () => {
          const hasMore = wrap.scrollWidth - wrap.clientWidth - wrap.scrollLeft > 4;
          wrap.classList.toggle('sk-guide-table-wrap--has-more', hasMore);
        };
        updateOverflow();
        wrap.addEventListener('scroll', updateOverflow, { passive: true });
        window.addEventListener('resize', updateOverflow, { passive: true });
      });
    }
    if (!content || !toc) return;
    const headings = Array.from(content.querySelectorAll('h2')).filter((h) => h.textContent.trim().length > 0);
    if (headings.length < 3) {
      toc.hidden = true;
      return;
    }
    const used = new Set();
    const list = document.createElement('ul');
    headings.forEach((heading, index) => {
      let base = heading.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section-' + (index + 1);
      let id = base;
      let i = 2;
      while (used.has(id) || document.getElementById(id)) {
        id = base + '-' + i++;
      }
      used.add(id);
      heading.id = id;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });
    const slot = toc.querySelector('[data-sk-guide-toc-list]');
    if (slot) slot.appendChild(list);
    toc.hidden = false;
  });
})();